const ns = {};

ns.SearchListControl = function() {

    this.uri = '/settings/toggle-search-list-fold';
    this.activeElement = null;
};

/**
 * Initialisiert die Buttons (Eventhandler-Registrierung).
 *
 * @returns {undefined}
 */
ns.SearchListControl.prototype.init = function() {

    var self = this;

    $(document).on('click', '.toggleFoldOptionButton', function() {
        self.activeElement = $(this);
        self.activeElement.addClass('loading');
        self.sendToggleRequest();
    });
};

/**
 * Gibt zurueck, ob die Suchoptionen eingeklappt sind. Funktioniert nur,
 * wenn activeElement gesetzt ist (z. B. im Click-Handler).
 *
 * @returns {Bool}
 */
ns.SearchListControl.prototype.isFolded = function() {
	return !this.activeElement.parents('.panel').find('#toggleSearch').hasClass('in');
};

ns.SearchListControl.prototype.sendToggleRequest = function() {

    var self = this;

    $.post(this.uri, {isFolded: this.isFolded()}, function(data) {
        self.activeElement.removeClass('loading');
    });
};

export default ns.SearchListControl;
